export const step_main_page = require("./assets/tutorial/step-main-page.png");
export const step_search = require("./assets/tutorial/step-search.png");
export const step_select = require("./assets/tutorial/step-select.png");
export const step_settings = require("./assets/tutorial/step-settings.png");
export const step_passengers = require("./assets/tutorial/step-passengers.png");
export const step_name_entry = require("./assets/tutorial/step-name-entry.png");
export const step_passengers_ready = require("./assets/tutorial/step-passengers-ready.png");
export const step_in_game = require("./assets/tutorial/step-in-game.png");
export const step_finit = require("./assets/tutorial/step-finit.png");
